import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { Chip } from "@mui/material";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { DbPriceRationCellRenderer } from "../column-def-cell-renderers/DbPriceRationCellRenderer";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { FilteredDynamoDbBackupSourceResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const dynamoDbBackupSourceColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Table Name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("dynamo_db_backup_source"),

  resourceAccountColumnDef,

  {
    field: "resource.status",
    headerName: "Table Status",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredDynamoDbBackupSourceResourceItem>) => {
      const status = data?.resource?.status;

      if (!status) {
        return "-";
      }

      const isActive = status?.toLowerCase() === "active";
      const label = isActive ? "available" : status;

      return (
        <Chip
          sx={{ textTransform: "capitalize" }}
          size="small"
          label={label}
          color={isActive ? "success" : "default"}
          variant="outlined"
        />
      );
    },
  },

  {
    field: "resource.db_price_ratio",
    headerName: "Backups Price Ratio",
    headerTooltip:
      "Shows the monthly cost of DynamoDB backups as a percentage of the DynamoDB table cost, helping you see how backup spending compares to your table. For example, if a table costs $5,000 per month and backups total $4,000, the ratio is 80%.",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredDynamoDbBackupSourceResourceItem>) => {
      const resource = data?.resource;

      if (!resource) {
        return null;
      }

      return (
        <DbPriceRationCellRenderer
          dbPrice={resource?.db_price}
          dbPriceRatio={resource?.db_price_ratio}
        />
      );
    },
  },

  { field: "resource.table_class", headerName: "Table Class" },

  { field: "resource.backup_count", headerName: "Backups per Table" },

  regionColumnDef,

  getResourceCreationTimeColumnDef("Created at"),

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,
];
